












































import { Component, Prop, Vue } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CloseIcon from '@/components/icons/Close.vue';
import ArrowBack from '@/components/icons/Arrow.vue';
import SuccessFeedback from '@/components/icons/SuccessFeedback.vue';
import FeaturesList from '@/componentsV2/molecules/FeaturesList/FeaturesList.vue';
import {
  transformWidgetPayload,
  transformWidgetSettingsToWidgetFormData
} from '@/views/Onboarding/helpers';
import { IWidgetSettings } from '@/models/Widget/settings';
import MerchantService from '@/api/MerchantService';
import AlertsService from '@/api/AlertsService';
import { features } from './featuresHelper';

@Component({
  components: {
    FilledButton,
    SuccessFeedback,
    CloseIcon,
    ArrowBack,
    FeaturesList
  }
})
export default class ActivateFeatureWidgetModal extends Vue {
  @Prop() onConfirm?: Function;
  @Prop() needActivation?: boolean;

  merchantService = new MerchantService();
  serviceAlert = new AlertsService();

  availableFeatures: any[] = [];
  success = false;
  loading = false;
  loadingFeatures = false;

  formData: any = {};

  features: any = features;

  get tPrefix() {
    return 'common.components.activateFeatureWidget';
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  async onSubmit() {
    if (this.business.coinPurchaseRatio === '0.00') {
      if (!this.formData.enabled) return;
      this.formData.enabled = false;

      eventBus.$emit('widgetConfigFormSetFormData', {
        ...this.formData
      });
      this.$notification(
        'Widget can only be activated after setting the reward rate.',
        'error',
        undefined,
        {
          onMessageClick: () => {
            this.onClose();
            this.$router.push('/coin/loyalty');
          }
        }
      );
      return;
    }
    this.loading = true;
    this.formData.enabled = true;
    const payload = transformWidgetPayload(this.formData);

    await this.updateWidgetProviderSettings(payload);
    this.$store.dispatch('merchant/UPDATE_WIDGET_PROVIDER_SETTINGS', payload);

    this.loading = false;

    if (this.onConfirm) this.onConfirm();

    this.success = true;
  }

  updateWidgetProviderSettings(widgetSettings: IWidgetSettings) {
    return this.merchantService.setConnectSettings(
      this.currentProvider.oauthId,
      widgetSettings
    );
  }

  onSuccessClick() {
    this.onClose();
    this.$notification(
      "Success! You've activated the widget on your website.",
      'success'
    );
  }

  async created() {
    if (this.currentProvider && this.currentProvider.settings)
      this.formData = transformWidgetSettingsToWidgetFormData(this
        .currentProvider.settings as IWidgetSettings);
    try {
      this.loadingFeatures = true;
      const { data } = await this.serviceAlert.getDeactivationWidgetFeatures();
      this.availableFeatures = data;
      const featuresAvailables = Object.keys(this.availableFeatures);

      this.features = this.features
        .filter((feature: any) => featuresAvailables.includes(feature.value))
        .map((feature: any) => {
          feature.description = feature.getDescription(
            this.availableFeatures[feature.value]
          );
          return feature;
        });
    } finally {
      this.loadingFeatures = false;
    }
  }
}
